import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	networkCodeContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		marginTop: '5rem'
	},
	output: {
		backgroundColor: '#D7DBDD',
		position: 'relative',
		borderRadius: '4px',
		margin: '4rem auto',
		marginTop: '1rem',
		overflowY: 'scroll !important',
		maxHeight: '80vh',
		textAlign: 'left',
		padding: '1rem',
		width: '99%',
		color: 'rgba(0, 0, 0, 0.38)'
	}
}));
